module.exports = __webpack_public_path__ + "static/media/cw.93e442a0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cw.svg
// module id = 802
// module chunks = 0